export default {"src":"/_next/static/media/art.2360d3ad.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};